module.exports = __webpack_public_path__ + "media/images/countryrect/gr-748169375caad3262f89ee002ba6cac9.svg";